module.exports = __webpack_public_path__ + "f26a66bd781275232e6bad3a49cc8174.png";